import React from 'react';
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import PageHeader from "../components/gamePlayComponents/PageHeader";
import {ToQuestion} from "../components/helpers/routes";
import {courses} from "../components/courseContent/courseObjects";
import {useNavigate} from "react-router-dom";
import ResetButton from "../components/gameSetupAndLobby/DeleteMyDataButtons";

const TestCourseLanding = () => {
  const navigate = useNavigate();
  const testCourseKey = courses.testCourse.key;
  const listStyle={
    marginTop: '8px'
  };

  return(<>
    <PageHeader title={'Test Course'}/>
    <Typography > Thank you for being a tester! </Typography>
    <Typography style={listStyle} >Questions to consider: </Typography>
    <ul>
      <li style={listStyle}> Is there anything that isn't immediately intuitive?</li>
      <li style={listStyle}> Are there any formatting things you'd change?</li>
      <li style={listStyle}>Is there anything broken?</li>
      <li style={listStyle}>Is the "unhappy path" (i.e. when the user gets things wrong) intuitive?</li>
    </ul>
    <div style={{width: '100%'}}>
    <Button variant={'contained'} onClick={() => navigate(ToQuestion(testCourseKey, 0))}
            color={'primary'} style={{width: '-webkit-fill-available', margin: '16px'}}> Launch </Button>
    </div>
    <hr/>
    <Typography style={{marginBottom: '8px', marginTop: '8px'}} >Important! When you're done, come back here and delete your data </Typography>
    <ResetButton/>
  </>)
};

export default TestCourseLanding;